import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { StyleSheet } from 'react-native';
import { Spacing } from '../../styles';
import { TouchableButton } from '../touchableButton';

type CancelButtonProps = {
  onCancel: () => void;
  showAlert?: () => void;
  confirmBack?: boolean;
  label?: string;
};

export const CancelButton: FC<CancelButtonProps> = (
  props: CancelButtonProps
) => {
  const { t } = useTranslation();
  const label = props.label || t('topNav.cancel');

  const onPress = () => {
    if (props.confirmBack && props.showAlert) {
      props.showAlert();
    } else {
      props.onCancel();
    }
  };

  return (
    <TouchableButton onPress={onPress} style={styles.left} label={label} />
  );
};

const styles = StyleSheet.create({
  left: {
    marginLeft: Spacing.baseMargin.base,
  },
});
